import { Validators } from '@angular/forms';

export const resetPasswordFields = [
  {
    type: 'password',
    label: 'Password',
    name: 'password',
    placeholder: 'Password',
    validation: [Validators.required],
    icon: 'password',
  },
  {
    type: 'password',
    label: 'Password Confirmation',
    name: 'confirmPassword',
    placeholder: 'Password Confirmation',
    validation: [Validators.required],
    icon: 'password',
  },
  {
    label: 'Submit',
    name: 'submit',
    cssClass: 'outlined',
    type: 'button',
  },
];
